import { PageId } from 'constants/pages'
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzVday80 } from './pages'

type TIdToPageMapWoofzVday80 = Record<PageIdWoofzVday80, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_VDAY_80: TIdToPageMapWoofzVday80 = {
  [PageId.SUBSCRIPTIONS_VDAY_80]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_vday/woofz_vday_80/pages/subscriptions/SubscriptionVday70'
      ).then((m) => ({
        default: m.SubscriptionsVday70,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_vday/woofz_vday_80/pages/subscriptions/SubscriptionVday70'
      ),
  },
  [PageId.CHAT_UPSELL_VDAY_80]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_vday/woofz_vday_80/pages/upsell/ChatUpsellNewFlow'
      ).then((m) => ({
        default: m.ChatUpsellNewFlow,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_vday/woofz_vday_80/pages/upsell/ChatUpsellNewFlow'
      ),
  },
  [PageId.UPSELL_VDAY_80]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_vday/woofz_vday_80/pages/upsell/Upsell').then(
        (m) => ({
          default: m.Upsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_vday/woofz_vday_80/pages/upsell/Upsell'),
  },
  [PageIdWoofzVday80.DOWNLOAD_VDAY_80]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_vday/woofz_vday_80/pages/download-app/DownloadApp'
      ).then((m) => ({
        default: m.DownloadApp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_vday/woofz_vday_80/pages/download-app/DownloadApp'
      ),
  },
  [PageIdWoofzVday80.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
